<template>
  <b-form @submit="onSubmit">
    <b-row>
      <b-col cols="2">
        <b-form-group label="Report Type">
          <b-form-select
            v-model="finalModel.inspectionReportTypeId"
            @change="reportChange"
            :disabled="inspectionDetails[FIELDS.INSPECTION_REPORT_TYPE_ID]>0"
          >
            <option value="344">Aegis Inspection</option>
            <option value="345">IDEA Inspection</option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <!--color="gray"-->
      <form-wizard
        shape="tab"
        color="#3498db"
        v-if="finalModel.inspectionReportTypeId=='344'"
        ref="aegis"
        @on-complete="onWizardComplete"
        :start-index="activeTabIndex"
      >
        <tab-content
          title="Common Details"
          icon="fa fa-building"
          :before-change="() => setData('common')"
        >
          <common
            :inventoryDetails="inventoryDetails"
            :inspectionDetails="inspectionDetails"
            ref="common"
          />
        </tab-content>
        <tab-content
          title="Shipment Details"
          icon="fa fa-truck"
          :before-change="() => setData('aegis-shipment')"
        >
          <aegis-shipment
            :inventoryDetails="inventoryDetails"
            :inspectionDetails="inspectionDetails"
            ref="aegis-shipment"
          />
        </tab-content>
        <tab-content
          title="Packaging"
          icon="fa fa-handshake-o"
          :before-change="() => setData('aegis-packaging')"
        >
          <aegis-packaging ref="aegis-packaging" :inspectionDetails="inspectionDetails" />
        </tab-content>
        <tab-content
          title="Surface Inspection"
          icon="fa fa-quote-left"
          :before-change="() => setData('aegis-surface')"
        >
          <aegis-surface ref="aegis-surface" :inspectionDetails="inspectionDetails" />
        </tab-content>
        <tab-content
          title="Lead Verification"
          icon="fa fa-credit-card"
          :before-change="() => setData('aegis-lead')"
        >
          <aegis-lead ref="aegis-lead" :inspectionDetails="inspectionDetails" />
        </tab-content>
        <tab-content
          title="QC Management"
          icon="fa fa-shopping-cart"
          :before-change="() => setData('aegis-qc-management')"
        >
          <aegis-qc-management ref="aegis-qc-management" :inspectionDetails="inspectionDetails" />
        </tab-content>
        <tab-content
          title="Part Acceptance"
          icon="fa fa-file-text-o"
          :before-change="() => setData('aegis-part-acceptance')"
        >
          <aegis-part-acceptance
            ref="aegis-part-acceptance"
            :inspectionDetails="inspectionDetails"
          />
        </tab-content>
        <template slot="footer" scope="props">
          <div class="wizard-footer-right">
            <wizard-button @click.native="props.prevTab()" v-if="props.activeTabIndex" class="wizard-footer-left mr-2" :style="props.fillButtonStyle">Previous</wizard-button>
            <wizard-button @click.native="props.nextTab()" :disabled="isSaving" class="wizard-footer-right" :style="props.fillButtonStyle">
              <i v-show="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>{{props.isLastStep ? 'Submit' : 'Next'}}</wizard-button>
          </div>
        </template>
      </form-wizard>
      <!--color="gray"-->
      <form-wizard
        shape="tab"
        v-if="finalModel.inspectionReportTypeId=='345'"
        ref="idea"
        color="#3498db"
        @on-complete="onWizardComplete"
        :start-index="activeTabIndex"
      >
        <tab-content
          title="Common Details"
          icon="fa fa-building"
          :before-change="() => setData('common')"
        >
          <common
            :inventoryDetails="inventoryDetails"
            :inspectionDetails="inspectionDetails"
            ref="common"
          />
        </tab-content>
        <tab-content
          title="Initial Inspection"
          icon="fa fa-undo"
          :before-change="() => setData('initial')"
        >
          <idea-initial ref="initial" :inspectionDetails="inspectionDetails" />
        </tab-content>
        <tab-content
          title="General Carton Inspection"
          icon="fa fa-calculator"
          :before-change="() => setData('general-carton')"
        >
          <idea-general-carton ref="general-carton" :inspectionDetails="inspectionDetails" />
        </tab-content>
        <tab-content
          title="Outer Product Carton Inspection"
          icon="fa fa-tasks"
          :before-change="() => setData('outer-product-carton')"
        >
          <idea-outer-product-carton
            ref="outer-product-carton"
            :inspectionDetails="inspectionDetails"
          />
        </tab-content>
        <tab-content
          title="Inner Contents Inspection"
          icon="fa fa-envelope"
          :before-change="() => setData('inner-contents')"
        >
          <idea-inner-contents ref="inner-contents" :inspectionDetails="inspectionDetails" />
        </tab-content>
        <tab-content title="Trays" icon="fa fa-archive" :before-change="() => setData('trays')">
          <idea-trays ref="trays" :inspectionDetails="inspectionDetails" />
        </tab-content>
        <tab-content
          title="Tubes"
          icon="fa fa-shopping-cart"
          :before-change="() => setData('tubes')"
        >
          <idea-tubes ref="tubes" :inspectionDetails="inspectionDetails" />
        </tab-content>
        <tab-content title="Reels" icon="fa fa-inbox" :before-change="() => setData('reels')">
          <idea-reels ref="reels" :inspectionDetails="inspectionDetails" />
        </tab-content>
        <tab-content title="Bulk" icon="fa fa-file-text-o" :before-change="() => setData('bulk')">
          <idea-bulk ref="bulk" :inspectionDetails="inspectionDetails" />
        </tab-content>
        <tab-content
          title="Detailed Inspection (Visual)"
          icon="fa fa-truck"
          :before-change="() => setData('visual-detailed')"
        >
          <idea-visual-detailed ref="visual-detailed" :inspectionDetails="inspectionDetails" />
        </tab-content>
        <tab-content
          title="Detailed Inspection (Solvents)"
          icon="fa fa-handshake-o"
          :before-change="() => setData('solvents-detailed')"
        >
          <idea-solvents-detailed ref="solvents-detailed" :inspectionDetails="inspectionDetails" />
        </tab-content>
        <tab-content
          title="Detailed Inspection (Mechanical)"
          icon="fa fa-credit-card"
          :before-change="() => setData('mechanical-detailed')"
        >
          <idea-mechanical-detailed
            ref="mechanical-detailed"
            :inspectionDetails="inspectionDetails"
          />
        </tab-content>
        <template slot="footer" scope="props">
          <div class="wizard-footer-right">
            <wizard-button @click.native="props.prevTab()" v-if="props.activeTabIndex" class="wizard-footer-left mr-2" :style="props.fillButtonStyle">Back</wizard-button>
            <wizard-button @click.native="props.nextTab()" :disabled="isSaving" class="wizard-footer-right" :style="props.fillButtonStyle">
              <i v-show="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>{{props.isLastStep ? 'Submit' : 'Next'}}</wizard-button>
          </div>
        </template>
      </form-wizard>
    </b-row>
  </b-form>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import service from '../../service';
import { InspectionReportDto, InspectionReport } from '../../dto';
import VueFormWizard from 'vue-form-wizard2';
import 'vue-form-wizard2/dist/vue-form-wizard.min.css';
import {FIELDS}  from '../../constants'
import {
  Common,
  AegisShipment,
  AegisPackaging,
  AegisPartAcceptance,
  AegisQcManagement,
  AegisSurface,
  AegisLead,
  IdeaInnerContents,
  IdeaMechanicalDetailed,
  IdeaOuterProductCarton,
  IdeaReels,
  IdeaSolventsDetailed,
  IdeaTrays,
  IdeaTubes,
  IdeaVisualDetailed,
  IdeaBulk,
  IdeaGeneralCarton,
  IdeaInitial,
} from '../wizard/index';

Vue.use(VueFormWizard);
export default {
  name: 'myFormWizard',
  components: {
    Common,
    AegisShipment,
    AegisPackaging,
    AegisSurface,
    AegisLead,
    AegisQcManagement,
    AegisPartAcceptance,
    IdeaInitial,
    IdeaGeneralCarton,
    IdeaOuterProductCarton,
    IdeaInnerContents,
    IdeaTubes,
    IdeaTrays,
    IdeaReels,
    IdeaBulk,
    IdeaVisualDetailed,
    IdeaSolventsDetailed,
    IdeaMechanicalDetailed,
  },
  props: {
    inventoryDetails: {
      type: Object,
      default: () => {},
    },
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters('account', ['userId']),
  },
  data() {
    return {
      dataItem: InspectionReport,
      finalModel: {
        inspectionReportTypeId: this.inspectionDetails[FIELDS.INSPECTION_REPORT_TYPE_ID] || 344,
      },
      activeTabIndex: 0,
      FIELDS:FIELDS,
      isSaving: false,
    };
  },
  methods: {
    async onSubmit(e) {
      e.preventDefault();

      this.$v.dataItem.$touch();
      if (this.$v.dataItem.$invalid) {
        return;
      }

      let payload = new InspectionReportDto(this.dataItem);
      payload.id = 0; //New records will start with an id of zero
      payload.active = true; //New records will always be true

      try {
        const id = await service.createInspectionReport(payload);
        this.redirectToListing();
      } catch {}
    },
    cancel() {
      this.redirectToListing();
    },
    redirectToListing() {
      this.$router.push({ name: 'InspectionReports' });
    },
    showModal() {
      this.$root.$emit('bv::show::modal', 'manage-report-modal', '#btnShow');
    },
    closeModal() {
      this.$root.$emit('bv::hide::modal', 'manage-report-modal');
    },
    reportChange(value) {
      //if (this.$refs.idea) this.$refs.idea.reset();
      //if (this.$refs.aegis) this.$refs.aegis.reset();
    },
    onWizardComplete() {
      this.finalModel.active = true;
      this.finalModel.purchaseOrderLineId = this.inspectionDetails[FIELDS.PURCHASE_ORDER_LINE_ID] || this.inventoryDetails.purchaseOrderLineId;
      this.finalModel.salesOrderLineId = this.inspectionDetails[FIELDS.SALES_ORDER_LINE_ID] || 0;
      this.finalModel.dateInspected = this.inspectionDetails[FIELDS.DATE_INSPECTED] || new Date().toISOString();
      this.finalModel.inspectedByUserId = this.inspectionDetails[FIELDS.INSPECTED_BY_USER_ID] || this.userId;
      this.finalModel.statusId = this.inspectionDetails[FIELDS.STATUS_ID] || 0;
      this.finalModel.inventoryId = this.inspectionDetails[FIELDS.INVENTORY_ID] || this.inventoryDetails.id;
      this.finalModel.ordered = this.inspectionDetails[FIELDS.ORDERED] || this.inventoryDetails.quantitySold;
      try {
        this.isSaving = true;
        if (this.inspectionDetails[FIELDS.ID] > 0) {
          try {
            this.finalModel.id = this.inspectionDetails[FIELDS.ID];
            service.updateInspectionReport(this.finalModel).then(() => {
              this.closeModal();
              this.$emit('refreshGrid')
            });
          } catch {
          }
        } else {
          this.finalModel.id = 0;
          try {
            service.createInspectionReport(this.finalModel).then((result) => {
              this.closeModal();
              this.$emit('refreshGrid')
            });
          } catch {
          }
        }
        this.isSaving = false;
      }catch (e) {
        this.isSaving = false;
      }
    },
    setData(ref) {
      this.finalModel = { ...this.finalModel, ...this.$refs[ref].model };
      return true;
    },
  },
  validations: {
    dataItem: {
      id: {},
      purchaseOrderLineId: {},
      salesOrderLineId: {},
      dateInspected: {},
      inspectedByUserId: {},
      statusId: {},
      inventoryId: {},
      ordered: {},
      orderDetailShippingPayMethod: {},
      orderDetailCodAmount: {},
    },
  },
  mounted() {
    //console.log(this.inspectionDetails,this.inspectionDetails[FIELDS.INSPECTION_REPORT_TYPE_ID]);
  },
};
</script>

<style lang="scss">
.vue-form-wizard {
  width: 100%;
}
.wizard-tab-content {
  padding: 15px 20px 10px;
}
.col-form-label {
  font-size: 100%;
}
</style>

